// ======================================================================
// File: src/modules/ipe/services/ipeEnquiryService.js
// Purpose:
//   IPE Enquiry + Engineering API client
//   (Aligned with backend /api/ipe routes)
// ======================================================================

import axiosClient from "../../../api/axiosClient";

/**
 * ----------------------------------------------------------------------
 * ENQUIRIES
 * ----------------------------------------------------------------------
 */

async function listEnquiries(params = {}) {

  const res = await axiosClient.get(
    "/api/ipe/enquiries",
    { params }
  );

  const payload = res.data?.data || {};

  const items = (payload.items || []).map(e => ({
    ...e,
    enquiry_no: e.enquiry_no,
  }));

  return {
    items,
    total: payload.total || 0,
    page: payload.page || 1,
    page_size: payload.page_size || params.page_size || 10,
  };

}


async function createEnquiry(payload) {

  const res = await axiosClient.post(
    "/api/ipe/enquiries",
    payload
  );

  return res.data?.data;

}


/**
 * ----------------------------------------------------------------------
 * ENQUIRY ITEMS
 * ----------------------------------------------------------------------
 */

async function listEnquiryItems(enquiryId) {

  const res = await axiosClient.get(
    `/api/ipe/enquiries/${enquiryId}/items`
  );

  return res.data?.data;

}


async function createEnquiryItem(enquiryId, payload) {

  const res = await axiosClient.post(
    `/api/ipe/enquiries/${enquiryId}/items`,
    payload
  );

  return res.data?.data;

}


/**
 * ----------------------------------------------------------------------
 * ENGINEERING BOM
 * ----------------------------------------------------------------------
 */

async function getActiveBOM(itemId) {

  const res = await axiosClient.get(
    `/api/ipe/boms/enquiry-items/${itemId}/bom`
  );

  return res.data?.data;

}


async function createBOM(payload) {

  const res = await axiosClient.post(
    `/api/ipe/boms/generate`,
    payload
  );

  return res.data?.data;

}


async function submitBOM(bomId) {

  const res = await axiosClient.post(
    `/api/ipe/boms/${bomId}/submit`
  );

  return res.data;

}


async function approveBOM(bomId) {

  const res = await axiosClient.post(
     `/api/ipe/boms/${bomId}/approve`
  );

  return res.data;

}


async function rejectBOM(bomId, reason) {

  const res = await axiosClient.post(
     `/api/ipe/boms/${bomId}/reject`,
    { reason }
  );

  return res.data;

}


async function replanBOM(bomId) {

  const res = await axiosClient.post(
    `/api/ipe/boms/${bomId}/replan`
  );

  return res.data;

}


/**
 * ----------------------------------------------------------------------
 * BOM LINES
 * ----------------------------------------------------------------------
 */

async function listBOMLines(bomId) {

  const res = await axiosClient.get(
     `/api/ipe/boms/${bomId}/lines`
  );

  return res.data?.data;

}


async function createBOMLine(payload) {

  const res = await axiosClient.post(
    `/api/ipe/boms/line`,
    payload
  );

  return res.data?.data;

}


async function updateBOMLine(lineId, payload) {

  const res = await axiosClient.put(
    `/api/ipe/boms/line/${lineId}`,
    payload
  );

  return res.data?.data;

}


async function deleteBOMLine(lineId) {

  const res = await axiosClient.delete(
    `/api/ipe/boms/line/${lineId}`
  );

  return res.data;

}


/**
 * ----------------------------------------------------------------------
 * MOM
 * ----------------------------------------------------------------------
 */
async function getMOM(itemId) {

  const res = await axiosClient.get(
    `/api/ipe/moms/enquiry-items/${itemId}/mom`
  );

  return res.data?.data;

}

async function generateMOM(payload) {

  const res = await axiosClient.post(
    "/api/ipe/moms/generate",
    payload
  );

  return res.data?.data;

}

async function updateMOMLine(lineId, payload) {

  const res = await axiosClient.put(
    `/api/ipe/moms/line/${lineId}`,
    payload
  );

  return res.data?.data;

}

async function deleteMOMLine(lineId) {

  const res = await axiosClient.delete(
    `/api/ipe/moms/line/${lineId}`
  );

  return res.data;

}
async function createMOMLine(payload) {

  const res = await axiosClient.post(
    `/api/ipe/moms/line`,
    payload
  );

  return res.data?.data;
}

async function saveProcessResourceMapping(payload) {

  const res = await axiosClient.post(
    "/api/ipe/moms/process-resource-mapping",
    payload
  );

  return res.data;

}
async function getMachineGroups() {
  const res = await axiosClient.get("/api/ppe/masters/machine-groups");

  return res.data.data || [];
}
async function getSkills() {
  const res = await axiosClient.get("/api/ppe/masters/skills");
  return res.data.data || [];
}
async function getOperations() {
  const res = await axiosClient.get("/api/ppe/masters/operations");
  return res.data.data || [];
}



/**
 * ----------------------------------------------------------------------
 * EXPORT
 * ----------------------------------------------------------------------
 */

const ipeEnquiryService = {

  // Enquiries
  listEnquiries,
  createEnquiry,

  // Enquiry Items
  listEnquiryItems,
  createEnquiryItem,

  // Engineering BOM
  getActiveBOM,
  createBOM,
  submitBOM,
  approveBOM,
  rejectBOM,
  replanBOM,

  // BOM Lines
  listBOMLines,
  createBOMLine,
  updateBOMLine,
  deleteBOMLine,

  // MOM
  getMOM,
generateMOM,
updateMOMLine,
deleteMOMLine,
createMOMLine,
getMachineGroups,
getSkills,
getOperations,
saveProcessResourceMapping,
};

export default ipeEnquiryService;